import { render, staticRenderFns } from "./cabinet-estates-list-cards.vue?vue&type=template&id=3e5faf74&scoped=true"
import script from "./cabinet-estates-list-cards.vue?vue&type=script&lang=js"
export * from "./cabinet-estates-list-cards.vue?vue&type=script&lang=js"
import style0 from "./cabinet-estates-list-cards.vue?vue&type=style&index=0&id=3e5faf74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5faf74",
  null
  
)

export default component.exports